/**
 * @fileoverview アプリケーションの共通レイアウトコンポーネント
 *
 * このファイルでは、アプリケーションのすべてのページで使用される基本レイアウト構造を定義しています。
 * ヘッダー、フッター、メインコンテンツエリアを含む共通のページ構造を提供します。
 */

import Footer from "@/components/footer";
import { Outlet } from "react-router";

/**
 * アプリケーションの共通レイアウトコンポーネント
 *
 * すべてのルートで共通して使用されるベースレイアウトを提供します。
 * 画面いっぱいに広がるフレックスコンテナを作成し、コンテンツエリアと
 * フッターを適切に配置します。
 *
 * @returns {JSX.Element} アプリケーションのレイアウト構造
 */
export default function AppLayout() {
  return (
    <div className="flex flex-col h-screen">
      <div className="flex flex-1 items-center justify-center">
        <Outlet />
      </div>
      <Footer className="flex justify-center mb-4" />
    </div>
  );
}
